const workProgressManage = [{
  desc: '查询工单列表',
  options: {
    url: '/workOrder/queryWorkOrderList',
    method: 'post'
  }
}]
export default workProgressManage



// WEBPACK FOOTER //
// ./src/api/workProgressManage.js